import StudentSummaryExporter from './StudentSummaryExporter';

export default StudentSummaryExporter;
